<template>
  <div class="recaptcha-container">
    <VueRecaptcha
      id="g-recaptcha"
      :sitekey="sitekey"
      :loadRecaptchaScript="true"
      @verify="validate"
      ref="recaptcha"
      @expired="onCaptchaExpired"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
// import Validation from '@/services/recaptchaValidate'
import recaptChaKey from '@/config/recaptChaKey'
export default {
  name: 'Recaptcha',
  components: { VueRecaptcha },

  computed: {
    ...mapState({
      resetCaptcha: state => state.recaptcha.reset,
    }),
  },

  watch: {
    resetCaptcha(val) {
      if (val === true) {
        this.onCaptchaExpired()
      }
    },
  },

  data() {
    return {
      sitekey: recaptChaKey,
      widgetId: 0,
    }
  },
  methods: {
    validate(response) {
      this.$store.commit('recaptcha/setKey', response)
      this.$emit('validate', response)
    },
    onCaptchaExpired: function() {
      this.$emit('validate', false)
      this.$store.commit('recaptcha/setKey', null)
      this.$refs.recaptcha.reset()
    },
  },
}
</script>

<style lang="stylus" scoped>
.recaptcha-container
    display flex
    justify-content center
</style>
